import { defineMessages } from 'react-intl';

export const InstallMeterDetailStepContent = defineMessages({
  meterMountTechnologyLabel: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
  meterMountTechnologyTooltip: {
    id: 'app.common.meterMountTechnologyTooltip',
    defaultMessage: 'Jaká technologie osazení měřidla',
  },
  meterMountTechnologyPlaceholder: {
    id: 'app.common.selectValid',
    defaultMessage: 'Vyber platné',
  },
  noRegisters: {
    id: 'app.common.noRegisters',
    defaultMessage: 'Neevidujeme žádné registry pro toto měřidlo.',
  },
  registers: {
    id: 'app.common.registers',
  },
  inbuiltOutputs: {
    id: 'app.common.inbuiltOutputs',
  },
  technology: {
    id: 'app.inventoryMeterOutput.technology',
  },
  remoteReadingOwner: {
    id: 'app.inventoryMeterOutput.remoteReadingOwner',
  },
  isOccupied: {
    id: 'app.inventoryMeterOutput.isOccupied',
  },
});

export const InstallMeterDetailStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
  tooltip: {
    id: 'app.common.allFieldsRequired',
    defaultMessage: 'Pro pokračování je třeba vyplnit všechna povinná pole!',
  },
});

export const RegisterSection = defineMessages({
  programmablePulsesExtra: {
    id: 'app.RegisterSection.programmablePulsesExtra',
    defaultMessage: 'POZOR! Toto měřidlo má nastavitelnou konstantu pulzů.',
  },
  ledRateHelp: {
    id: 'app.RegisterSection.ledRateHelp',
    defaultMessage: 'LED Konstanta pulzů je {led_rate}',
  },
  registerObis: {
    id: 'app.RegisterSection.registerObis',
    defaultMessage: 'Register {register} (OBIS)',
  },
  registerFactorLabel: {
    id: 'app.RegisterSection.registerFactorLabel',
    defaultMessage: 'Konstanta pulzů na jednotku',
  },
  registerFactorRequired: {
    id: 'app.RegisterSection.registerFactorRequired',
    defaultMessage: 'Zadej prosím konstantu pulzů na měřidle',
  },
  registerFactorValidationMessage: {
    id: 'app.RegisterSection.registerFactorValidationMessage',
    defaultMessage: 'Konstanta pulzů na jednotku musí být větší než 0',
  },
  dataSourceChannelLabel: {
    id: 'app.RegisterSection.dataSourceChannelLabel',
    defaultMessage: 'Kanál/Input',
  },
  dataSourceChannelPlaceholder: {
    id: 'app.RegisterSection.dataSourceChannelPlaceholder',
    defaultMessage: 'Vyber kanál',
  },
  channel: {
    id: 'app.common.channel',
    defaultMessage: 'Kanál',
  },
  registerCounterPlaceholder: {
    id: 'app.common.registerCounterPlaceholder',
    defaultMessage: 'Stav registru při osazení',
  },
  registerRequired: {
    id: 'app.common.registerRequired',
    defaultMessage: 'Zadejte stav registru',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
  registerPhotosRequired: {
    id: 'app.common.registerPhotosRequired',
    defaultMessage: 'Vyfoť prosím stav registru',
  },
});
